angular
    .module('empower.claimPerformanceReport')
    .controller('claimPerformanceReportController', ['$scope', 'claimPerformanceReportService', '$filter', 'commonConst', 'jurisdictionEnum',
        function ($scope, claimPerformanceReportService, $filter, commonConst, jurisdictionEnum) {
            $scope.jurisdictionEnum = jurisdictionEnum;
            $scope.isNotData = false;
            $scope.CPRSection = [];
            $scope.isCprLoaded = false;
            $scope.isInfoLoaded = false;
            $scope.isInterimPolicy = false;
            $scope.pageName = 'Reporting';
            $scope.pageBreadcrumbs = [{url: '/', title: 'Home'}, {url: null, title: 'Reporting'}];

            $scope.formData = {
                policyId: null,
                finishDate: null,
                asAt: getCurrentDate()
            }

            $scope.selectedData = {
                policy: null
            };
            
            $scope.$on('policySelectionChanged', function (event, policy) {
                $scope.CPRSection = [];
                $scope.isCprLoaded = false;
                $scope.isInfoLoaded = false;

                if (!!policy && policy.EmployerId) {
                    //$scope.formData.finishDate = null;
                    //getPolicyYearList(policy);
                }
            });

            $scope.$watch('formData.finishDate', function () {
                $scope.CPRSection = [];
                $scope.isInfoLoaded = false;
                $scope.isCprLoaded = false;
            }, true);

            $scope.$watch('formData.asAt', function () {
                $scope.CPRSection = [];
                $scope.isInfoLoaded = false;
                $scope.isCprLoaded = false;
            }, true);

            $scope.createReport = function () {
                getCPREmployerInfo($scope.formData.policyId);

                $scope.isCprLoaded = false;
                getCPRReport($scope.formData.policyId, $scope.formData.finishDate, $scope.formData.asAt);
            } // createReport

            $scope.downloadPdf = function () {
                claimPerformanceReportService.getCPRReportPdf($scope.formData.policyId, $scope.formData.finishDate, $scope.selectedData.policy.PolicyNumber,  $scope.formData.asAt)
                .then(function() {
                    sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.POLICY);
                    sessionStorage.Policy = $filter('enstr64')(JSON.stringify($scope.selectedData.policy));
                });
            } // downloadPdf

            function getPolicyYearList(policy) {
                if (policy.StatusCode === 'INTERIM') {
                    $scope.isInterimPolicy = true;
                    return;
                }

                $scope.isInterimPolicy = false;
                claimPerformanceReportService.getPolicyYearList(policy.EmployerId).then(function (result) {
                    $scope.finishDateData = result;
                });
            } // getPolicyYearList

            function getCPREmployerInfo(policyId) {
                claimPerformanceReportService.getCPREmployerInfo(policyId).then(function (result) {
                    $scope.isInfoLoaded = true;
                    $scope.cprEmployerInfo = result;
                });
            } // getCPREmployerInfo

            function getCPRReport(policyId, finishDate, asAt) {
                claimPerformanceReportService.getCPRReport(policyId, finishDate, asAt).then(function (result) {
                    $scope.isCprLoaded = true;
                    if (result.length == 0) {
                        $scope.isNotData = true;
                        return;
                    }
                    $scope.isNotData = false;
                    $scope.CPRSection.splice(0, $scope.CPRSection.length);
                    for (var index = 0; index < result.length; index++) {
                        var cprSection = new CPRSectionModel(result[index]);
                        $scope.CPRSection.push(cprSection);
                    }

                    sessionStorage.RecentlySelectedType = $filter('enstr64')(commonConst.POLICY);
                    sessionStorage.Policy = $filter('enstr64')(JSON.stringify($scope.selectedData.policy));
                });
            } // getCPRReport

            $scope.checkAsAtDate = function(){
                var asAt = $scope.formData.asAt;
                if (!isValidDateTimeFormat(asAt) || !moment(asAt, 'DD/MM/YYYY').isBefore(moment())) {
                    $scope.formData.asAt = getCurrentDate();
                }
            }

            function getCurrentDate() {
                var date = new Date();
                var year = date.getFullYear();
              
                var month = (1 + date.getMonth()).toString();
                month = month.length > 1 ? month : '0' + month;
              
                var day = date.getDate().toString();
                day = day.length > 1 ? day : '0' + day;
                
                return day + '/' + month + '/' + year;
            }

            function isValidDateTimeFormat(date, isDateHourFormat) {
                var isValid = true;
                var format = commonConst.DATE_FORMAT;
                if (!!isDateHourFormat) {
                    format = commonConst.DATETIME_FORMAT;
                }
                if (!moment(date, format, true).isValid()) {
                    isValid = false;
                }
                return isValid;
            };
        }
    ]);